import { PlusIcon } from '@heroicons/react/24/outline';
import { ADD_VA_BUTTON } from './virtualAppointmentActionStyles';

interface AddVirtualAppointmentButtonProps {
    onAdd: () => void;
}

export function AddVirtualAppointmentButton({ onAdd }: AddVirtualAppointmentButtonProps) {
    return (
        <button type="button" onClick={onAdd} className={ADD_VA_BUTTON}>
            <PlusIcon className="w-3.5 h-3.5" />
            Add VA
        </button>
    );
}
